import { FormattedMessageProps } from '../../../components/FormattedMessage';
import PagesRouterFormattedMessage from './PagesRouterFormattedMessage';
import ServerFormattedMessage from './ServerFormattedMessage';

/**
 * Select the correct FormattedMessage component based on the environment.
 */
const FormattedMessageWrapper = ({
  isPagesRouter,
  ...props
}: FormattedMessageProps & { isPagesRouter?: boolean }) => {
  if (isPagesRouter) {
    return <PagesRouterFormattedMessage {...props} />;
  }
  return <ServerFormattedMessage {...props} />;
};

export default FormattedMessageWrapper;
